import PostMessageController from 'src/pc/store/cloudGame/PostMessageController'
import { searchToQuery } from 'src/pc/store/cloudGame/utils'

const query = searchToQuery(location.search)

const CloudGamePagePostMessage = new PostMessageController({
  postWin: window.parent,
  postOrigin: decodeURIComponent(query?.get('parent') || ''),
})

export default CloudGamePagePostMessage
